import { SafeHydrate } from "@/SafeHydrate";
import * as React from "react";
import { MessageCircle } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";
const teamMembers = [{
  name: "Sarah Jenkins",
  position: "Committee Chair",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687108/img/committee_sarah_jenkins.png"
}, {
  name: "Marcus Thompson",
  position: "Event Coordinator",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687108/img/committee_marcus_thompson.png"
}, {
  name: "Jessica Chen",
  position: "Alumni Outreach",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687108/img/committee_jessica_chen.png"
}, {
  name: "David Miller",
  position: "Finance & Logistics",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687108/img/committee_david_miller.png"
}];
export default function ReunionCommittee() {
  return <section data-section-id="234913" id="reunion-committee" className="relative bg-background text-foreground py-16 md:py-24 overflow-hidden">
      {}
      <div className="absolute inset-0 z-0 opacity-[0.05] pointer-events-none bg-[linear-gradient(to_right,#eab308_1px,transparent_1px),linear-gradient(to_bottom,#eab308_1px,transparent_1px)] bg-[size:32px_32px]" aria-hidden="true" />

      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center max-w-2xl mx-auto mb-12 md:mb-16">
          <h2 className="font-default text-3xl md:text-5xl font-bold text-primary mb-4 tracking-tight">
            Reunion Committee
          </h2>
          <p className="text-muted-foreground font-default text-lg uppercase tracking-widest">
            The dedicated team bringing us back together
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8 justify-center">
          {teamMembers.map((member, i) => <div data-index={i} key={i}>
              <Card className="h-full flex flex-col items-center text-center p-6 border border-primary/20 shadow-lg hover:shadow-xl transition-all duration-300 bg-secondary/50 backdrop-blur-md rounded-lg">
                <CardContent className="p-0 flex flex-col items-center w-full h-full">
                  <SafeHydrate><Avatar className="size-[120px] mb-6 border-4 border-primary shadow-md">
                    <AvatarImage src={member.image} alt={member.name} className="object-cover grayscale hover:grayscale-0 transition-all duration-500" />
                    <AvatarFallback className="text-2xl font-default font-semibold bg-primary text-primary-foreground">
                      {member.name.split(' ').map(n => n[0]).join('')}
                    </AvatarFallback>
                  </Avatar></SafeHydrate>
                  
                  <h3 className="font-default text-xl font-bold text-primary mb-1">
                    {member.name}
                  </h3>
                  
                  <p className="text-foreground/80 font-default text-sm mb-6 flex-grow uppercase tracking-wider">
                    {member.position}
                  </p>
                  
                  <Button variant="outline" size="icon" className="mt-auto rounded-lg border-primary/40 text-primary hover:bg-primary hover:text-primary-foreground transition-colors shadow-sm" aria-label={`Contact ${member.name}`}>
                    <MessageCircle className="size-5" />
                  </Button>
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}